import { render, staticRenderFns } from "./TenantApprovalQueue.vue?vue&type=template&id=0312f53e&scoped=true&"
import script from "./TenantApprovalQueue.vue?vue&type=script&lang=js&"
export * from "./TenantApprovalQueue.vue?vue&type=script&lang=js&"
import style0 from "./TenantApprovalQueue.vue?vue&type=style&index=0&id=0312f53e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312f53e",
  null
  
)

export default component.exports